type Flattenable = Record<string, any> | string | number | null | undefined;

export function flattenQuery<T extends Flattenable>(query: T): Record<string, string | number> {
  if (!query) return {};
  if (typeof query === "string" || typeof query === "number") {
    return { value: query };
  }

  const result: Record<string, string | number> = {};

  const flatten = (obj: any, prefix = ""): void => {
    Object.entries(obj).forEach(([key, value]) => {
      if (value === null || value === undefined) return;

      const newKey = prefix ? `${prefix}.${key}` : key;

      if (Array.isArray(value)) {
        result[newKey] = value.join(",");
      } else if (typeof value === "object") {
        flatten(value, newKey);
      } else if (typeof value === "string" || typeof value === "number") {
        result[newKey] = value;
      }
    });
  };

  flatten(query);
  return result;
}

export function searchParamsQuery(query: Record<string, string | number | undefined | null>) {
  const searchParams = new URLSearchParams();
  if (!query) return searchParams;
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });
  return searchParams;
}
